import { logger } from '../../Util';
import DataState from '../../Types/DataState';
import {
  GetContactsInput,
  PastContact,
  UpdateSavedContactInput,
  UpdateSavedContactResponse,
  SavedContactAction,
} from './schema';
import { TimeOption } from '../../PerformancePortal/Dashboard/DashboardComponents/LighthouseMetrics/types';
import moment from 'moment';
import { getAmazonWeekAsGGGGDashWW } from '@amzn/aet-generic-kit';

export const prepareGetContactsDataQuery = (
  userID: string,
  cscEntityPrefix: string,
  timeOption: TimeOption = TimeOption.DAILY,
  timestamp?: string
): GetContactsInput => {
  // Default to today's date for DAILY, or current week for WEEKLY
  const defaultTimestamp =
    timeOption === TimeOption.DAILY
      ? moment().format('YYYY-MM-DD')
      : getAmazonWeekAsGGGGDashWW(moment());

  return {
    userId: `${cscEntityPrefix}:${userID}`,
    alias: userID,
    timeOption,
    timestamp: timestamp ?? defaultTimestamp,
  };
};

export const prepareUpdateSavedContactQuery = (
  userId: string,
  cscEntityPrefix: string,
  contact: PastContact
): UpdateSavedContactInput => {
  return {
    userId: `${cscEntityPrefix}:${userId}`,
    contactId: contact.COMM_ID,
    dateAndTime: contact.TIME,
    channel: contact.CHANNEL_NAME,
    duration: contact.CALL_DURATION_SECONDS?.toString() ?? '0',
    sic: contact.SIC_NODE_1_NAME,
    ownershipType: contact.OWNERSHIP_TYPE.toString(),
    action: contact.SAVED ? SavedContactAction.REMOVE : SavedContactAction.ADD,
  };
};
